import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import PaymentMethodItem from '../MyAccount/paymentMethods/Item';
import AddOnPurchase from './purchase';
import { Button } from '../form';
import { updatedUserMethodsByProduct } from '../../utils/payments';
import { useTrackingScripts } from '../../utils/hooks/useInjectScripts';

const UserPaymentMethods = ({
  title,
  history,
  userData,
  deleteCouponCode,
  userPaymentMethods,
  changeFavoriteUserPaymentMethod,
  newUserPaymentMethods,
  productsToBuy,
  subPaymentMethods,
  ...props
}) => {
  const [modalAddExtra, setModalAddExtra] = useState(false);
  const [userPaymentMethod, setUserPaymentMethod] = useState(null);
  const [availableUserPaymentMethods, setAvailableUserPaymentMethods] = useState([]);
  const [query, setQuery] = useState(null);

  useTrackingScripts(props.plan);

  useEffect(() => {
    props.getPaymentMethodsByUser();
  }, [props.getPaymentMethodsByUser]);

  useEffect(() => {
    if (query) return;

    const params = new URLSearchParams(history.location.search);
    const paramsObject = Object.fromEntries(params.entries());

    setQuery(paramsObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.search]);

  const onCancel = () => {
    deleteCouponCode();
    history.goBack();
  }

  const selectPaymentMethod = (userPaymentMethod) => {
    setModalAddExtra(true);
    setUserPaymentMethod(userPaymentMethod);
  }
  const newPaymentMethod = () => {
    const currentSubPaymentMethod = subPaymentMethods.find(sub => sub.countryCode.toLowerCase() === query.country.toLowerCase() && sub.active);

    history.push(`methods/${currentSubPaymentMethod.paymentMethod}/${currentSubPaymentMethod.type}${history.location.search}`, { defaultPaymentChange: true });
  }

  useEffect(() => {
    if (userPaymentMethods?.length > 0) {
      setAvailableUserPaymentMethods(userPaymentMethods);
      const filteredUserMethods = updatedUserMethodsByProduct(
        props.isSingleSubscriptionClient,
        productsToBuy[0],
        userPaymentMethods,
        userData.country,
        props.currentPaymentMethod
      );
      setAvailableUserPaymentMethods(filteredUserMethods);
    }
  }, [userPaymentMethods, productsToBuy, props.isSingleSubscriptionClient, props.currentPaymentMethod, userData.country]);

  return (
    <div className="MethodSelectionPage">
      <Row>
        <div className="PaymentMethodSelector">
          {title && (
            <Row>
              <Col md={8}>
                <div className="PaymentMethodSelector__title">
                  {title}
                </div>
              </Col>
            </Row>
          )}
          <Row>
            <Col md={12}>
              {Array.isArray(availableUserPaymentMethods) && availableUserPaymentMethods.map((item) => (
                <PaymentMethodItem
                  key={item._id}
                  item={item}
                  selectPaymentMethod={selectPaymentMethod}
                  paymentMethodsLength={availableUserPaymentMethods.length}
                />
              ))}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="PaymentMethodSelector__new-method">
                <Button
                  onClick={newPaymentMethod}
                  color="link"
                  className="paymentMethods__addNewMethod"
                >
                  <FormattedMessage
                    id="MyAccount.paymentMethdos.addNewMethod"
                  />
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="PaymentMethodSelector__back-container">
                <div className="PaymentMethodSelector__back">
                  <Button className="empty" onClick={onCancel}>
                    <FormattedMessage id="PaymentMethodSelector.cancel" />
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <AddOnPurchase
          userPaymentMethod={userPaymentMethod}
          modalAddExtra={modalAddExtra}
          setModalAddExtra={setModalAddExtra}
          forceToChangeToFavorite={true}
          setUserPaymentMethod={setUserPaymentMethod}
        />
      </Row>
    </div>
  )
};

UserPaymentMethods.propTypes = {
  userData: PropTypes.shape({
    country: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
  }).isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.node
  ]),
  getPaymentMethodsByUser: PropTypes.func.isRequired,
  deleteCouponCode: PropTypes.func.isRequired,
  userPaymentMethods: PropTypes.array,
  isSingleSubscriptionClient: PropTypes.bool,
  currentPaymentMethod: PropTypes.string,
  productsToBuy: PropTypes.array,

  newUserPaymentMethods: PropTypes.func.isRequired,
  changeFavoriteUserPaymentMethod: PropTypes.func.isRequired,
};

export default UserPaymentMethods;
